import { ReactElement } from "react";
import { Link } from "react-router-dom";

export default function NewsFeedsBanner(): ReactElement {
  return (
    <header className="news-feeds-banner">
      <h1>
        <span>World News</span>
      </h1>
      <nav aria-label="breadcrumb">
        <ol className="news-feeds-breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li aria-hidden="true">&gt;</li>
          <li>Resources</li>
          <li aria-hidden="true">&gt;</li>
          <li>News &amp; Articles</li>
          <li aria-hidden="true">&gt;</li>
          <li aria-current="page">World News</li>
        </ol>
      </nav>
    </header>
  );
}
